import React from 'react';
export const Footer = () => {
  return <footer className="border-t border-gray-200 pt-6 text-sm text-gray-600" data-id="element-192">
      <div className="flex items-start mb-6" data-id="element-193">
        <img src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Amee Buijs" className="w-16 h-16 rounded-full object-cover mr-4 flex-shrink-0" data-id="element-194" />
        <div data-id="element-195">
          <p className="font-semibold mb-2" data-id="element-196">
            Amee Buijs is gespecialiseerd hondengedragstherapeut en oprichtster
            van Stressless Dogs.
          </p>
          <p data-id="element-197">"Helping dogs live stress-free lives since 2017"</p>
        </div>
      </div>
      <div className="text-xs border-t border-gray-200 pt-4 pb-2" data-id="element-198">
        <p className="text-gray-500 mb-3" data-id="element-199">
          Meta Advertising Disclaimer: Deze website maakt gebruik van Meta Pixel
          voor advertentiedoeleinden. Dit betekent dat informatie over uw bezoek
          aan deze website wordt gedeeld met Meta (Facebook) om gerichte
          advertenties te kunnen tonen. Door gebruik te maken van deze website
          gaat u akkoord met het gebruik van cookies en vergelijkbare
          technologieën voor analytische en advertentiedoeleinden. Deze pagina
          is een advertorial voor Stressless Dogs. Stressless Dogs is een
          onafhankelijk bedrijf en is op geen enkele wijze verbonden aan of
          onderdeel van Meta (voorheen Facebook). Deze advertentie wordt getoond
          via het Meta advertentieplatform, maar Meta is niet verantwoordelijk
          voor de inhoud of diensten aangeboden door Stressless Dogs.
        </p>
        <p className="text-center text-gray-500" data-id="element-200">
          © 2024 Stressless Dogs. Alle rechten voorbehouden.
        </p>
      </div>
    </footer>;
};